export default () => ({
    eventId: null,
    venues: [],
    showAddModal: false,
    venue: {
        account: {},
        notes: null,
        status: 'New',
        amount: null,
    },
    statuses: [
        'New',
        'Sent',
        'Quoted',
        'Accepted',
        'Rejected',
    ],
    deleteVenueId: null,
});
